export default "__VITE_ASSET__C93JoscH__"